import axios from '@core_utils/api/_axios.js'
import dayjs from 'dayjs';

export default {
    namespaced: true,
    state: {
        contractor: {
            accesstoken: null,
            user_name: null,
            user_id: null,
            e_mail: null,
            company_name: null,
            company_id: null,
            is_authenticated: null,
            is_admin: null,
            type: null
        },
        project_list: [],
        request_time: null,
        project: null
    },
    getters: {
        Get_Contractor (state) {
            return state.contractor
        },
        GET_ProjectList (state) {
            return state.project_list
        },
        GET_Project (state) {
            return state.project
        },
        GET_CONTRACTOR_REQEUST_TIME (state) {
            return state.request_time
        }
    },
    mutations: {
        SET_PROJECT_LIST (state, list) {
            state.project_list = list
        },
        SET_PROJECT (state, project_code) {
            let _project = null 
            if (!state.project_list.length) {
                _project = null
            } else {
                if (project_code === 'latest') {
                    _project = state.project_list[0]
                } else if (project_code && project_code !== 'latest') {
                    _project = state.project_list.find(({ project_code: _project_code }) => _project_code === project_code)
                    _project = !_project ? null : _project
                } else {
                    _project = null
                }
            }

            state.project = _project
        },
        SET_CONTRACTOR_REQUEST_TIME (state) {
            // state.request_time = !state ? null : dayjs(new Date()).format('YYYY/M/D/ HH:mm:ss')
            state.request_time = !state ? null : new Date()
        },
        SET_CONTRACTOR_ACCOUNT (state, payload) {
            const _contract_account = {}
            for (const _info_key in payload) {
                _contract_account[_info_key.toLocaleLowerCase()] = payload[_info_key]
            }
            state.contractor = _contract_account
        },
        SET_CONTRACTOR_INITIAL (state) {
            state.contractor = {
                accesstoken: null,
                user_name: null,
                user_id: null,
                e_mail: null,
                company_name: null,
                company_id: null,
                is_authenticated: null,
                is_admin: null,
                type: null
            }
        }
    },
    actions: {
        async LogoutContractor ({ state, commit }) {
            // eslint-disable-next-line no-useless-catch
            try {
                for (const key in state.contractor) {
                    localStorage.removeItem(key)
                }
                // 토큰 키 통일: state.contractor 에 없는 카멜 'accessToken' 과 'type' 도 명시 제거.
                // (없으면 로그아웃 후에도 stale accessToken + type=request 가 남아 guard 가
                //  ContractorProgress 로 되돌려보내 로그아웃이 실패한다.)
                localStorage.removeItem('accessToken')
                localStorage.removeItem('accesstoken')
                localStorage.removeItem('type')
                await axios.post(process.env.VUE_APP_BACKENDHOST + '/logout')
                commit('SET_CONTRACTOR_INITIAL')
                commit('SET_PROJECT_LIST', [])
                commit('SET_CONTRACTOR_REQUEST_TIME', null)
            } catch (error) {
                throw error
            }
        }
    }
}